import { UniButton } from '@/design-system/components/buttons';
import { ButtonVariant } from '@/design-system/components/buttons/useButton.hook';
import { UniCheckbox } from '@/design-system/components/inputs';
import { ModalHeader } from '@/design-system/components/modal';
import { TextBody } from '@/design-system/components/typography';
import { TextSmall } from '@/design-system/components/typography/UniTypography';
import { SxProp, View, Image } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface ReplaceCardProps {
  onClose: () => void;
  onStep: (step: string) => void;
}

export const ReplaceCardWebTwoScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose, onStep } = props;
  const { t } = useTranslation('account-management');
  const { topHeader, body, textMb, itemStyle, flexContainer, address, textColor, itemAlign } = sxStyles;
  const [selected, setSelected] = useState<boolean>(false);
  const onSelectChange = (value: boolean) => {
    setSelected(value);
  };
  const onBtnPlaceInstructionClick = () => {
    if (!!selected) {
      setSelected(false);
      onStep('three');
    }
  };
  return (
    <View>
      <View sx={topHeader}>
        <ModalHeader title="Replace Card Instruction Confirmation" closeModal={onClose} />
      </View>
      <View sx={body}>
        <TextBody sx={textMb} semiBold>
          You have requested to place the following instruction:
        </TextBody>
        <View sx={{ gap: 12 }}>
          <TextBody sx={itemStyle}>
            <TextBody secondary>Reason to replace card</TextBody>
            <TextBody>It’s lost/stolen</TextBody>
          </TextBody>
          <TextBody sx={itemAlign}>
            {/* <View sx={flexContainer}> */}
            <TextBody secondary>Delivery Method</TextBody>
            <TextBody sx={address}>
              Mail to address: <br /> Block 1, 1/F, Flat A, Super
              <br /> Building, 1 Sample Road, <br />
              Jordan, Hong Kong
            </TextBody>
            {/* </View> */}
          </TextBody>
          <TextBody sx={itemStyle}>
            <TextBody secondary>Replacement Fee</TextBody>
            <TextBody sx={textColor}>- 50.00 HKD</TextBody>
          </TextBody>
        </View>
        <TextSmall sx={{ marginTop: 4 }} secondary>
          Will be deducted from HK Account
        </TextSmall>
        <UniCheckbox
          label="By clicking “Place Instruction”, you are aware that your current credit card will be deactivated and a new one will be arranged."
          value={selected}
          onValueChange={(value) => onSelectChange(value)}
          verticalAlignCenter
          sx={{ mt: '$5', alignItems: 'flex-start', color: '$textSecondary' }}
        />
        <View sx={{ flex: 1, display: 'grid', gap: '$3', mt: '$10', height: 44, gridTemplateColumns: '1fr 1fr' }}>
          <UniButton variant={ButtonVariant.outline1} sx={{ width: 216, height: 44 }} label="Cancel" onPress={onClose} />
          <UniButton
            sx={{ width: 216, height: 44 }}
            label="Place Instruction"
            disabled={!selected}
            onPress={() => onBtnPlaceInstructionClick()}
          />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    height: 70,
    justifyContent: 'center'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  textMb: {
    marginBottom: 20
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 20
  },
  itemAlign: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  title: {
    color: '$textSecondary',
    fontSize: 12
  },
  address: {
    textAlign: 'right',
    lineHeight: 20
  },
  textColor: {
    color: '#F5423E'
  }
};
